(() => {
  if (window.feDispoBound) return;
  window.feDispoBound = true;
  function init(root) {
    root.querySelectorAll('.fe-dispo [role="tablist"]').forEach(list => {
      if (list.dataset.ready) return;
      list.dataset.ready = 'true';
      const tabs = [...list.querySelectorAll('[role="tab"]')];
      function select(tab) {
        tabs.forEach(t => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1;
          const panel = list.closest('.fe-dispo').querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', e => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
          e.preventDefault();
          const n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(tabs[n]); tabs[n].focus();
        });
      });
    });
    root.querySelectorAll('.fe-dispo video').forEach(v => {
      if (v.dataset.ready) return;
      v.dataset.ready = 'true';
      v.addEventListener('play', () => document.querySelectorAll('.fe-dispo video').forEach(other => {if (other !== v) other.pause();}));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('visibilitychange', () => {if (document.hidden) document.querySelectorAll('.fe-dispo video').forEach(v => v.pause());});
})();
